import { Component } from '@angular/core';

import { HeaderComponent } from '@theme/header/header.component';

import {
  ContentShellComponent,
  EmptyStateComponent,
  PanelHeaderComponent,
} from '@shared/components/content-panel';

@Component({
  selector: 'app-apis',
  templateUrl: './apis.component.html',
  styleUrl: './apis.component.scss',
  imports: [ContentShellComponent, EmptyStateComponent, HeaderComponent, PanelHeaderComponent],
})
export class ApisComponent {}
